import Socket from '../connection/socket';
import { showAlert } from '../components/general-components/alert-service';

function handleErrorToaster(message: any) {
	const { error, description } = message.message;

	if (!error || !description) return;

	showAlert({
		message: error,
		description: description,
		duration: 7000,
		type: 'error'
	})
}

export default function Errors(socket: Socket) {
	socket.addListener('error-toaster', handleErrorToaster);
}